export default __webpack_public_path__ + "static/media/gallery-4.e6321b41.jpg";